// removed by extract-text-webpack-plugin
module.exports = {"photo":"photo_1J2_C","backgroundImage":"backgroundImage_y_frN","date":"date_3rXDS","useCount":"useCount_1oc_N"};


//////////////////
// WEBPACK FOOTER
// ./app/components/photo/styles.scss
// module id = 494
// module chunks = 1